import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { of,Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { OPD_LANG } from "../properties/opd-lang-properties";
import moment from "moment";
import { ERStatusColor } from "../enums/encounter-status.enum";
import { AppBaseService } from "projects/lib/medcare-core-lib/src/lib/services/http.service";


@Injectable()
export class GeneralUrlService {
  selectedLang: string;
  multLangDilaogs: any[] = [];

  constructor(
    private baseservice: AppBaseService,
    public translate: TranslateService
  ) {
    this.selectedLang = localStorage.getItem(OPD_LANG.langCode);
    translate.addLangs(OPD_LANG.langList);
    this.translate.use(this.selectedLang);
    this.translate.get("dialogs").subscribe((data: any) => {
      this.multLangDilaogs = data;
    });
  }

 
  getTypeApi(serviceUrl: string, urlType: string): Observable<any[]> {
    this.baseservice.setResourceURL(serviceUrl);

    return this.baseservice
      .getResource(urlType)
      .pipe(catchError(this.handleError<any[]>()));
  }

  /**
   *
   *
   * @param {string} urlType
   * @param {*} payload
   * @return {*}  {Observable<any[]>}
   * @memberof MasterUrlService
   */
 
  postTypeApi(serviceUrl: string, urlType: string, payload: any): Observable<any[]> {
    this.baseservice.setResourceURL(serviceUrl);

    return this.baseservice
      .postResource(urlType, payload)
      .pipe(catchError(this.handleError<any[]>()));
  }

  /**
   *
   *
   * @param {string} urlType
   * @param {*} payload
   * @return {*}  {Observable<any[]>}
   * @memberof MasterUrlService
   */
   
  putTypeApi(serviceUrl: string, urlType: string, payload: any): Observable<any[]> {
    this.baseservice.setResourceURL(serviceUrl);
    
    return this.baseservice
      .putResource(urlType, payload)
      .pipe(catchError(this.handleError<any[]>()));
  }
  patchTypeApi(serviceUrl: string, urlType: string, payload: any): Observable<any[]> {
    this.baseservice.setResourceURL(serviceUrl);
    
    return this.baseservice
      .patchResource(urlType, payload)
      .pipe(catchError(this.handleError<any[]>()));
  }

  private handleError<T>() {
    return (error: any): Observable<T> => {
      console.log(`failed: ${error.message}`);

      return of(error);
    };
  }
  convertDateFormat(dateStr: string): string {
    if (!dateStr) {
      return '';
    }
    const [year, month, day] = dateStr.split('-');
    return `${day}-${month}-${year} / `;
  }
  formatDateWithRelativeTime(date: Date): string {
    if (!date) {
      return '';
    }
    let newDate = new Date();
    const relativeTime = moment(date).fromNow(); 
    return `(${relativeTime})`;
  }
  calculateAge(dateOfBirth: string): string {
    if (!dateOfBirth) {
      return '';
    }
    let birthDate = new Date(dateOfBirth);
    let currentDate = new Date();
  
    let years = currentDate.getFullYear() - birthDate.getFullYear();
    let months = currentDate.getMonth() - birthDate.getMonth();
    let days = currentDate.getDate() - birthDate.getDate();
    if (days < 0) {
      months--;
      days += new Date(currentDate.getFullYear(), currentDate.getMonth(), 0).getDate();
    }
    if (months < 0) {
      years--;
      months += 12;
    }
    return `${years} Y, ${months} M, ${days} D`;
  }
  getGenderValue(value: string): string {
    let Value = value.toUpperCase();
    switch (Value) {
      case "MALE":
        return "male-blue.png";
      case "FEMALE":
        return "female-pink.png";
      default:
        return "other-gray.png";
    }
  }
  getGender(value: string): string {
    let Value = value.toUpperCase();
    switch (Value) {
      case "MALE":
        return "M";
      case "FEMALE":
        return "F";
      default:
        return "O";
    }
  }
  getstatusColor(status: string): { text: string; backgroundColor: string } {
    let style: { text: string; backgroundColor: string } = {
      text: "",
      backgroundColor: "",
    };
    switch (status) {
      case "Blocked":
        style.text = "Blocked";
        style.backgroundColor = ERStatusColor.requested;
        break;
      case "unBlocked":
        style.text = "unBlocked";
        style.backgroundColor = ERStatusColor.rejected;
        break;
        case "CTOS Blocked":
          style.text = "CTOS Blocked";
          style.backgroundColor = ERStatusColor.cancelled;
          break;
      default:
        break;
    }
    return style;
  }
}
